
<div class="content-container bg-white">

  <h1>{{ 'communicationChannel.information.title.view' | translate }}</h1>

  <div class="btn-bar" [appHasAnyPermission]="[PermissionKeys.gestionCommunication]">
    <button class="btn btn-primary" [routerLink]="['manage']">
      <span translate="communicationChannel.information.btn.manageInformations"></span>
    </button>
  </div>

  @if (informationArray.length === 0) {
    <h5>{{ 'communicationChannel.information.empty' | translate }}</h5>
  }

  <!-- Information List -->
  @if (informationArray.length > 0) {
    <div class="communication-channel-list-container">
      @for (information of informationArray; track information) {
        <div class="list-item-container"
          (click)="readInformation(information.id)"
          (keyup)="readInformation(information.id)">
          <div class="icon-container">
            <img class="icon" src="../assets/icons/communication_channel_information.svg" alt="icon" height="60px" width="auto">
          </div>
          <div class="content-container">
            <h3 translate="">{{ information['title' + crtLang.toUpperCase()] }}</h3>
            <h6>{{ information.publicationDate | date }}</h6>
          </div>
        </div>
      }
    </div>
  }

</div>
